import { useTableActionContext } from '@aibees/elephant/context';
import {
  OperationMode,
  TemplateManagementDialog,
} from '@aibees/shared/features';
import { ExportTemplateMaxValueError } from '@aibees/shared/features/template-management-dialog/components/export-template-max-value-error';
import { memo, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTemplateContext } from '../../context/TemplateContext';
import { useExportTemplateDataType } from '../../hooks/use-export-template-data-type';
import { useExportTemplateDefaultItem } from '../../hooks/use-export-template-default-item';
import type { ExportSettingDialogProps as Props } from './types';

export const ExportTemplateCreateDialog = memo(
  ({ className: _className }: Props) => {
    const dataType = useExportTemplateDataType();
    const defaultItems = useExportTemplateDefaultItem();

    const {
      setSelectedTemplate,
      setTemplateMode,
      templateName,
      selectedTemplate,
      templateMode,
    } = useTemplateContext();
    const { templateDialogState, exportDialogState, integrationConfig } =
      useTableActionContext();

    const { getValues } = useFormContext();

    const dialogTitle = useMemo(() => {
      return templateMode === OperationMode.EDIT
        ? 'Edit Template'
        : 'Create New Template';
    }, [templateMode]);

    const handleClose = () => {
      templateDialogState.onFalse();
      exportDialogState.onTrue();
      setTemplateMode(OperationMode.CREATE);
    };

    return (
      <>
        {dataType && (
          <TemplateManagementDialog
            open={templateDialogState}
            onClose={handleClose}
            onBack={handleClose}
            dialogIcon="file-csv-outline"
            dialogTitle={dialogTitle}
            defaultItems={defaultItems}
            dataType={dataType}
            mode={templateMode}
            templateName={templateName}
            error={
              <ExportTemplateMaxValueError
                integrationConfig={integrationConfig}
              />
            }
            integrationConfig={integrationConfig}
            selectedTemplate={selectedTemplate}
            checkedValues={getValues}
            setSelectedTemplate={setSelectedTemplate}
          />
        )}
      </>
    );
  }
);

ExportTemplateCreateDialog.displayName = 'ExportTemplateCreateDialog';
